import styled from "styled-components";

import { colorsPalettes, fonts, setFontVariant, setFont } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";

const StyledIconButton = styled(Button)<{ disabled?: boolean }>`
    display: flex;
    min-width: 0px;
    padding: 10px;

    ${({ disabled }) => disabled && { opacity: 0.5, pointerEvents: "none" }}

    ${setFont({
        $size: 14,
        $weight: "normal",
        $color: colorsPalettes.carbon[0],
        $family: fonts.$robotoFontFamily,
    })};

    & > div {
        color: ${colorsPalettes.carbon[0]};
    }

    > div.SWReactIcons {
        svg {
            height: 16px;
            width: 16px;

            & path {
                fill: ${colorsPalettes.carbon[0]};
            }
        }
    }

    &:hover {
        > div.SWReactIcons {
            svg {
                & path {
                    fill: ${colorsPalettes.carbon[0]};
                }
            }
        }
    }

    & > .SWReactIcons {
        svg path {
            fill: ${colorsPalettes.carbon[0]};
        }

        height: auto;
        margin-right: 10px;
        margin-top: 3px;
    }
`;

export const StyledHomePageIconButton = styled(StyledIconButton)`
    color: ${colorsPalettes.carbon[500]};
    font-size: 12px;

    & > div {
        color: ${colorsPalettes.carbon[500]};

        &.SWReactIcons {
            height: auto;
            margin-right: 10px;
            margin-top: 3px;

            svg {
                height: 16px;
                width: 16px;

                & path {
                    fill: ${colorsPalettes.carbon[500]};
                }
            }
        }
    }

    &:hover {
        > div.SWReactIcons {
            svg {
                & path {
                    fill: ${colorsPalettes.carbon[500]};
                }
            }
        }
    }
`;

export const StyledColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const StyledSupportWrapper = styled.div`
    display: flex;
    margin-bottom: 28px;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
`;

export const StyledHomePageWrapper = styled(StyledSupportWrapper)`
    margin-bottom: 0;
    align-items: center;
`;

export const StyledWelcomeTitleText = styled.div`
    display: flex;
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
    font-weight: 400;
`;

export const LoadSpinner = styled(Spinner)`
    display: inline-block;
    vertical-align: baseline;
    width: 0.4em;
    height: 0.4em;
    margin-right: 12px;
`;
